import React, { useContext } from "react";
import {
    TreeContext,
    ComponentContext,
    DialogContext,
    SearchValueContext,
    SiteColorContext,
} from "../../Store";

// Unterkomponente zum ausgewählten Bauteil anlegen
import CreateSubCompDialog from "./Dialog/CreateComp/CreateSubCompDialog";
// gefilterte Tree-Elemente
import { SearchList } from "./CatalogItems/SearchList";
// Bauteil Editor
import EditComp from "./EditComp";

import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { withStyles, makeStyles } from "@mui/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import UserService from "../../../services/UserService";
import RenderOnRole from "../../RenderOnRole";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

// Baumdarstellung Bauteilliste

const useStyles = makeStyles({
    treeView: {
        textAlign: "left",
    },
    buttonLight: {
        float: "right",
        fontWeight: "bold",
    },
    buttonDark: {
        float: "right",
        fontWeight: "bold",
        color: "#e5e5e5",
    },
    gesamtView: {
        display: "flex",
        alignItems: "flex-start",
        flexGrow: "5",
        border: "1px solid #4D6F8C",
        borderRadius: "0px",
        height: "95vh",
        margin: "20px",
    },
    katalogView: {
        display: "flex",
        flexDirection: "column",
    },
    btSearchRow: {
        display: "flex",
        alignItems: "center",
        padding: "0px 10px",
    },
    btSearch: {
        flexGrow: 1,
    },
    btListe: {
        maxHeight: "85vh",
        width: "400px",
        float: "left",
        overflowY: "auto",
        overflowX: "hidden",
    },
    showParent: {
        display: "flex",
        marginLeft: "30px"
    },
    btNeu: {
        marginLeft: "8px",
        flexShrink: 0,
    },
    darkColor: {
        color: "#e5e5e5",
    },
});

function DataTreeView({ treeItems }) {
    const classes = useStyles();

    return (
        <SimpleTreeView
            className={classes.treeView}
            slots={{ collapseIcon: ExpandMoreIcon, expandIcon: ChevronRightIcon, endIcon: ArrowRightIcon }}
        >
            <SearchList items={treeItems} />
        </SimpleTreeView>
    );
}

// Suchfeld wenn Seite hell
const CssTextFieldLight = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "#633437",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#2D3A42",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#2D3A42",
            },
            "&:hover fieldset": {
                borderColor: "#2D3A42",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#2D3A42",
            },
        },
    },
})(TextField);

// Suchfeld wenn Seite dunkel
const CssTextFieldDark = withStyles({
    root: {
        "& label": {
            color: "#e5e5e5",
        },
        "& label.Mui-focused": {
            color: "#e5e5e5",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#e5e5e5",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#e5e5e5",
            },
            "&:hover fieldset": {
                borderColor: "#e5e5e5",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#e5e5e5",
            },
        },
    },
})(TextField);

const ShowParent = (x) => {
    if (x) {
        for (const value of x.values()) {
            return (<div>Zugehörig zu: {value.name}</div>);
        }
    }
};

const TreeComponent = () => {
    const tree = useContext(TreeContext);
    const component = useContext(ComponentContext);
    const dialog = useContext(DialogContext);
    const [SiteColor] = useContext(SiteColorContext);
    const [SearchValue, setSearchValue] = useContext(SearchValueContext);
    const classes = useStyles();

    return (
        <div>
            <div className={classes.gesamtView}>
                <div className={classes.katalogView}>
                    <div className={classes.btSearchRow}>
                        <form className={classes.btSearch}>
                            {SiteColor ? (
                                <CssTextFieldLight
                                    autoFocus
                                    margin="dense"
                                    id="SearchCata"
                                    variant="outlined"
                                    label="Katalog durchsuchen"
                                    type="text"
                                    fullWidth
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />
                            ) : (
                                <CssTextFieldDark
                                    autoFocus
                                    margin="dense"
                                    id="SearchCata"
                                    variant="outlined"
                                    label="Katalog durchsuchen"
                                    type="text"
                                    fullWidth
                                    InputProps={{ className: classes.darkColor }}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />
                            )}
                        </form>
                        <RenderOnRole roles={['MAP_ADMIN', 'ADMIN_MAP', 'TWIN_DATA_ADMIN']}>
                            <div className={classes.btNeu}>
                                {SiteColor ? (
                                    <Button
                                        className={classes.buttonLight}
                                        onClick={() => dialog.setSubOpen(true)}
                                    >
                                        <AddIcon /> Neu
                                    </Button>
                                ) : (
                                    <Button
                                        className={classes.buttonDark}
                                        onClick={() => dialog.setSubOpen(true)}
                                    >
                                        <AddIcon /> Neu
                                    </Button>
                                )}
                            </div>
                        </RenderOnRole>
                    </div>
                    {SearchValue ? <div className={classes.showParent}>{ShowParent(tree.parent)}</div> : null}
                    <div className={classes.btListe}>
                        <DataTreeView treeItems={tree.items} />
                    </div>
                </div>
                <CreateSubCompDialog />
                {component.isSelected ? <EditComp /> : null}
            </div>
        </div>
    );
};

export default TreeComponent;
